<template>
  <v-application v-if="access.inv_productions">
    <v-layout row class="ma-2">
      <v-flex md12>
        <v-crud-card
          name="production"
          to="/inventory/productions"
          view
          v-bind:headers="headers"
          v-bind:data="productions"
          no-delete
          v-bind:num-pages="productions_total"
          v-model="productions_page"
          @change-pagination="changePagination"
          :data_loading="data_loading"
          v-bind:add_button_name="'add_production'"
          showSearch
          InventoryProduction
          v-bind:search_text="search_text"
          v-bind:getData="update_productions"
          v-bind:searchActivate="
            (state) => {
              search_text = state;
            }
          "
          v-bind:setText="
            (text) => {
              search = text;
            }
          "
        >
          <template #top>
            <v-combobox
              v-model="type"
              label="Status"
              v-bind:items="types"
              hide-details
              item-text="name"
              class="mx-1"
            />
            <v-combobox
              v-model="store"
              label="Store"
              v-bind:items="stores"
              hide-details
              item-text="name"
              class="mx-1"
            />
          </template>
        </v-crud-card>
      </v-flex>
    </v-layout>
  </v-application>
  <error404 v-else></error404>
</template>
<script>
import Services from "../../mixins/services";
import Production from "../../mixins/inventory/production";
export default {
  name: "InventoryProductions",
  mixins: [Services, Production],
  data: () => ({
    headers: [
      { text: "Production", value: "p_order" , available: true},
      { text: "Date", value: "created_time", available: true },
      { text: "Store", value: "service_name", available: true },
      { text: "Type", value: "type" , available: true},
      { text: "Quantity", value: "quality" , available: true},
    ],
    data: [],
    search_text: false,
    search: "",
  }),
  methods: {
    changePagination(page) {
      this.productions_page = page;
      this.update_productions();
    },
  },
  mounted() {
    this.headers = [
      { text: this.$t("production"), value: "p_order" , available: true},
      { text: this.$t("date"), value: "created_time" , available: true},
      { text: this.$t("store"), value: "service_name" , available: true},
      { text: this.$t("type"), value: "type", available: true },
      { text: this.$t("quantity"), value: "quality", available: true },
    ];
    for (const index in this.headers) {
      this.headers[index]["sortable"] = false;
    }
  },
  watch: {
    store: {
      deep: true,
      handler() {
        this.$store.commit("setItemsService", this.store);
        this.update_productions();
      },
    },
    type: {
      deep: true,
      handler() {
        this.update_productions();
      },
    },
  },
  beforeMount() {
    this.store = this.$store.state.items_current_service;
    this.access = this.$store.state.access;
  },
};
</script>